import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { Projectile } from '../Projectile';
import { SLING_THROWER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class SlingThrower extends BaseUnit {
    private attackTimer: number = 0;
    private throwPhase: number = 0;
    private projectiles: Projectile[];

    constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, projectiles: Projectile[]) {
        super(scene, x, y, slotIndex);
        this.projectiles = projectiles;
        this.targetPriority = 'fastest';
        this.draw();
    }

    getDamage(): number {
        const perUnitDamage = Math.round(SLING_THROWER.baseDamage * this.bonusDamageMult * this.globalDamageMult);
    return perUnitDamage * this.stackCount;
    }

    getSlowEffect(): number {
        // Lower = more slow. bonusSlowEffect reduces the multiplier (stronger slow)
        return Math.max(0.1, SLING_THROWER.slowEffect - this.bonusSlowEffect);
    }

    getSlowDuration(): number {
        return SLING_THROWER.slowDuration + this.bonusSlowDuration;
    }

    update(time: number, delta: number, enemies: Enemy[]): void {
        // Animate throw
        if (this.throwPhase > 0) {
            this.throwPhase -= delta * 0.004;
            if (this.throwPhase < 0) this.throwPhase = 0;
        }

        // Fire at nearest enemy
        this.attackTimer -= delta;
        if (this.attackTimer <= 0) {
            const target = this.findTarget(enemies, SLING_THROWER.range);
            if (target) {
                this.attackTimer = this.getEffectiveAttackInterval(SLING_THROWER.attackInterval);
                this.throwPhase = 1;
                this.fire(target);
            } else {
                this.attackTimer = 0;
            }
        }

        this.draw();
    }

    getProjectileCount(): number {
        return 1 + this.bonusProjectiles;
    }

    private fire(target: Enemy): void {
        const count = this.getProjectileCount();
        const spread = 25;

        for (let i = 0; i < count; i++) {
            const offsetY = count > 1 ? (i - (count - 1) / 2) * spread : 0;
            const proj = new Projectile(this.scene, this.x + 10, this.y - 10, {
                damage: this.getDamage(),
                speed: SLING_THROWER.projectileSpeed,
                piercing: false,
                projectileType: 'sling_stone',
                targetX: target.x,
                targetY: target.y + offsetY,
                slowEffect: this.getSlowEffect(),
                slowDuration: this.getSlowDuration(),
            });
            this.projectiles.push(proj);
        }
    }

    draw(): void {
        if (this.throwPhase <= 0) {
            this.sprite.setTexture('friendly_sling_idle');
        } else {
            let frame = Math.floor((1 - this.throwPhase) * 8);
            if (frame < 0) frame = 0;
            if (frame > 7) frame = 7;
            this.sprite.setTexture(`friendly_sling_${frame}`);
        }

        this.graphics.clear();
        if (this.level > 1) {
            this.graphics.fillStyle(0xffd700, 1);
            for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
                this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
            }
        }
    }
}
